import SearchWorkspace from '@/components/google-ads/search/SearchWorkspace';
import { LEADS_OBJECTIVE } from './leadsObjective';

/** LEADS WORKSPACE — /google-ads/leads */
export default function LeadsPage() {
  return <SearchWorkspace objective={LEADS_OBJECTIVE} />;
}
